module.exports = __webpack_public_path__ + "static/media/fuer-unternehmen-hero.a8dc93e9.jpg";